import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { RegisterForm } from "layout/Auth/RegisterForm";
import { Button, Heading, Img, Input, Text } from "components";
import Cache from "utils/cache";
import { ChangePasswordForm } from "layout/Auth/ChangePasswordForm";

export default function ChangePassword() {
	return (
		<div className="flex flex-col items-center justify-start w-full bg-[#E5E7EB]">
			<div className="relative w-full">
				<Header />
			</div>
			<div className=" py-20 grid grid-cols-1 md:grid-cols-2 gap-10  max-w-[480px] w-full md:w-[480px] px-5 md:px-10 mt-10 min-h-screen-min-topbar">
				<div className="flex flex-col items-start justify-start w-full gap-5">
					<Text size="lg" as="p" className="!text-red-300 !font-sueellenfrancisco">
						Change Password
					</Text>

					<div className="flex flex-row justify-start items-center gap-5 w-full">
						<ChangePasswordForm />
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}
